import { render, staticRenderFns } from "./SfCharacteristic.vue?vue&type=template&id=615160f5"
import script from "./SfCharacteristic.vue?vue&type=script&lang=js"
export * from "./SfCharacteristic.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfCharacteristic.vue?vue&type=style&index=0&id=615160f5&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "123b759c"
  
)

export default component.exports